import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Navigation from "../../../../components/Navigation";
import BottomAppBar from "../../../../components/BottomBar";
import { useSelector } from "react-redux";
import { StarsSubChildCat } from "../../../../http/server-apis";
import Loader from "../../../../components/loaders/Loader";
import CategoryDetail from "../../../../components/home/category/CategoryDetail";
import CategoryContent from "../../../../components/home/category/CategoryContent";

const SubCategDetail = () => {
  const { selectedLanguage } = useSelector((state) => state.Language);
  const { state } = useLocation();
  const params = useParams();
  const { Title, AppBarColor,  } = state;
  const [childSubCategoryData, setchildSubCategoryData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const getCategory = useCallback(async () => {
    setIsLoading(true);
    const { data } = await StarsSubChildCat("post", {
      data: {
        SubCatID: params.subcateg_id,
        LangCode: selectedLanguage,
      },
    });
    if (data.Status === "success") {
      setchildSubCategoryData(data);
    }

    setIsLoading(false);
  }, [params, selectedLanguage]);

  useEffect(() => {
    getCategory();
  }, [params, getCategory]);
  return (
    <>
      <Navigation
        title={Title || "Subcategory"}
        appBarColor={AppBarColor || "orange"}
      />
      <div className="fixed-layout-main flex">
        {isLoading ? (
          <div className="white-card my-2">
            <Loader />
          </div>
        ) : (
          <>
            <div className="white-card my-2 ">
              {childSubCategoryData && childSubCategoryData.HasSubChild === 0 ? (
                <CategoryDetail
                  categoryData={childSubCategoryData.CategoriesDetails[0]}
                  HasChild={childSubCategoryData.HasSubChild.toString()}
                  color={AppBarColor}
                />
              ) : (
                <>
                  <CategoryContent
                    HasChild={childSubCategoryData?.HasSubChild}
                    categoryData={childSubCategoryData?.Subcategories}
                    Title={Title}
                    AppBarColor={AppBarColor}
                  />
                </>
              )}
            </div>
          </>
        )}
      </div>

      <BottomAppBar />
    </>
  );
};

export default SubCategDetail;
